import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const CashMgmtAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.cashMgmtAccess
        ? setValues((j) => ({
            ...j,
            cashMgmt: {
              add: true,
              remove: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            cashMgmt: {
              add: false,
              remove: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.cashMgmtAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      cashMgmt: { ...j.cashMgmt, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.cashMgmtAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Add"
          checked={values.cashMgmt?.add || false}
          name={"add"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Remove"
          checked={values.cashMgmt?.remove || false}
          name={"remove"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default CashMgmtAccess;
